/**
 * Canali in copia (spec 2026-10-15, parte A): funzioni pure condivise da
 * modale di trasferimento v3, pannello rapido v4 e card Proprietà.
 */
import type { CopyGroupRef, GroupLite } from '../../services/supportApi';

/** Id dei canali in copia: dal dettaglio (`copyGroups`) o dalla riga della coda (`copyGroupIds`). */
export const currentCopyIds = (t?: { copyGroups?: CopyGroupRef[]; copyGroupIds?: string[] } | null): string[] =>
  t?.copyGroups ? t.copyGroups.map((g) => g.id) : (t?.copyGroupIds || []).map(String);

/**
 * Canali che si possono mettere in copia: attivi, mai lo smistamento
 * (`inboundDefault`, il backend risponde 400), mai il responsabile
 * (`responsibleId`) né quelli in `exclude` (già in copia).
 */
export const copyGroupOptions = (
  groups: GroupLite[],
  { responsibleId, exclude = [] }: { responsibleId?: string; exclude?: string[] }
): GroupLite[] =>
  (groups || []).filter(
    (g) => g.isActive !== false && g.inboundDefault !== true && g._id !== responsibleId && !exclude.includes(g._id)
  );

/** Nomi dei canali indicati: dai canali noti, altrimenti dai riferimenti del dettaglio; ignoti saltati. */
export const copyGroupNames = (ids: string[], groups: GroupLite[], refs: CopyGroupRef[] = []): string[] =>
  ids
    .map((id) => (groups || []).find((g) => g._id === id)?.nome || refs.find((r) => r.id === id)?.nome || '')
    .filter(Boolean);

/** Quarto argomento di `transfer`: presente solo con copie scelte (senza, la chiamata è quella di prima). */
export const transferArgs = (copyGroupIds?: string[]): [] | [string[]] =>
  copyGroupIds && copyGroupIds.length ? [copyGroupIds] : [];
